// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class InvoiceSummaryDto extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** DateTime key */
  invoiceMonthStart!: Date;
  /** Int32 */
  invoiceCount!: number;
  /** Decimal */
  invoiceTotalAmt!: number;
}

